export default __webpack_public_path__ + "static/media/login_page_image.84bbc9b6.png";